/* design-light · navx (Header B) behavior overrides — durable layer.
   Loaded (deferred) from snippets/dl-head.liquid. Runs before dl-navx.js. */
(function(){
  var mq = window.matchMedia('(max-width:1023px)');

  /* Brand logos: inject collections' logo images into wordmark-fallback tiles. */
  var CDN = 'https://cdn.shopify.com/s/files/1/1019/3852/8590/collections/';
  var LOGOS = {
    'artemide': CDN + 'artemide-logo-png-transparent.png?v=1779189617',
    'grau': CDN + 'GRAU_Logo_Black_Clear-Space_RGB_2022-2.png?v=1779190620',
    'ingo-maurer': CDN + 'ingo-maurer-logo_png.webp?v=1779189645',
    'santacole': CDN + 'logo-santa-cole-alt.png?v=1779197787',
    'creative-cables': CDN + 'CA_logo_orizzontale_negativo_png.png?v=1779200622',
    'vitae': CDN + 'vitae-orange-logo.svg?v=1780048895',
    'spectrasol': CDN + 'logo-15.png?v=1779203967'
  };
  Array.prototype.forEach.call(document.querySelectorAll('.navx-btile'), function(tile){
    var word = tile.querySelector('.word');
    if(!word){ return; }
    var href = tile.getAttribute('href') || '';
    var parts = href.split('/collections/');
    if(parts.length < 2){ return; }
    var handle = parts[1].split('?')[0].split('#')[0];
    if(handle.slice(-1) === '/'){ handle = handle.slice(0, -1); }
    var url = LOGOS[handle];
    if(!url){ return; }
    var img = document.createElement('img');
    img.src = url; img.alt = word.textContent; img.loading = 'lazy';
    word.parentNode.replaceChild(img, word);
  });

  /* Mobile drawer logo -> homepage. */
  var dlogo = document.querySelector('.navx-drawer .hd .navx-logo');
  if(dlogo){ dlogo.addEventListener('click', function(){ window.location.href = '/'; }); }

  /* Move burger + search icon into the red utility bar on mobile; restore on desktop. */
  function placeHeader(){
    var util = document.querySelector('.navx-util');
    if(!util){ return; }
    var burger = document.querySelector('[data-navx] .navx-burger');
    var find = document.querySelector('[data-navx] .navx-find');
    var tools = util.querySelector('.tools');
    var catbar = document.querySelector('.navx-catbar');
    if(mq.matches){
      if(burger && burger.parentNode !== util){ util.insertBefore(burger, util.firstChild); }
      if(find && tools && find.parentNode !== util){ util.insertBefore(find, tools); }
    } else if(catbar){
      if(find && find.parentNode !== catbar){ catbar.appendChild(find); }
      if(burger && burger.parentNode !== catbar){ catbar.appendChild(burger); }
    }
  }
  placeHeader();
  if(mq.addEventListener){ mq.addEventListener('change', placeHeader); }
  else if(mq.addListener){ mq.addListener(placeHeader); }
  document.addEventListener('DOMContentLoaded', placeHeader);

  /* ===== Mobile unified search-in-drawer ===== */
  (function(){
    var drawer = document.querySelector('.navx-drawer');
    var bd = drawer && drawer.querySelector('.bd');
    if(!drawer || !bd){ return; }

    var PH = 'Hledejte svítidla, značky nebo místnosti…';
    var si = document.querySelector('[data-navx-search] [data-search-input]');
    if(si && si.getAttribute('placeholder')){ PH = si.getAttribute('placeholder'); }

    function esc(s){ return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function money(v){ if(v == null || v === ''){ return ''; } var n = parseFloat(v); if(isNaN(n)){ return esc(v); } return Math.round(n).toLocaleString('cs-CZ') + ' Kč'; }

    var wrap = document.createElement('div');
    wrap.className = 'dl-dsearch';
    var field = document.createElement('div');
    field.className = 'dl-dsearch-field';
    field.innerHTML = '<svg class="ic" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>';
    var input = document.createElement('input');
    input.type = 'search'; input.className = 'dl-dsearch-input'; input.placeholder = PH;
    input.autocomplete = 'off'; input.setAttribute('enterkeyhint', 'search');
    var clear = document.createElement('button');
    clear.type = 'button'; clear.className = 'dl-dsearch-clear'; clear.setAttribute('aria-label', 'Smazat'); clear.hidden = true;
    field.appendChild(input); field.appendChild(clear);

    /* curated empty-state suggestions */
    var CHIPS = [
      ['Závěsná svítidla', '/collections/zavesna-svitidla'],
      ['Stolní lampy', '/collections/stolni-lampy'],
      ['LED žárovky', '/collections/led-zarovky'],
      ['Textilní kabely', '/collections/creative-cables-elektricke-kabely'],
      ['Ikony', '/collections/ikony']
    ];
    var suggest = document.createElement('div');
    suggest.className = 'dl-dsearch-suggest';
    suggest.innerHTML = '<div class="dl-dsearch-sec">Oblíbené kategorie</div><div class="dl-dsearch-chips">' +
      CHIPS.map(function(c){ return '<a class="dl-dsearch-chip" href="' + c[1] + '">' + esc(c[0]) + '</a>'; }).join('') +
      '</div><div class="dl-dsearch-sec">Oblíbené produkty</div><div class="dl-dsearch-feat"></div>';

    var results = document.createElement('div');
    results.className = 'dl-dsearch-results'; results.hidden = true;
    wrap.appendChild(field); wrap.appendChild(suggest); wrap.appendChild(results);
    bd.insertBefore(wrap, bd.firstChild);

    /* Both the featured tiles and the search results are now the STORE'S OWN product card, fetched
       through Shopify's Section Rendering API rather than rebuilt from JSON. /...?section_id=<id>
       returns just that section's markup, so the drawer gets .pcard exactly as the collection and
       search pages render it - badges (Vystaveno, Bazar, Poslední kus...), the price chip on the
       photo, the brand mark, the srcset and the hover image - with no badge or brand logic
       duplicated here. Rebuilding it from suggest.json was never going to match: that payload
       carries no tags, so the badges could not be derived at all.
       The cost is honest: a section response is bigger than a JSON one. It is debounced, and only
       the cards are kept - the rest of the parsed document is discarded. */
    function cardsFrom(html, limit){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('.pcard');
      var frag = document.createDocumentFragment();
      for(var i = 0; i < cards.length && i < limit; i++){ frag.appendChild(cards[i].cloneNode(true)); }
      return { frag: frag, total: cards.length };
    }

    var featLoaded = false;
    function loadFeatured(){
      if(featLoaded){ return; }
      featLoaded = true;
      fetch('/collections/ikony?section_id=dl-collection-grid', { headers: { 'Accept': 'text/html' } })
        .then(function(r){ return r.text(); })
        .then(function(html){
          var feat = suggest.querySelector('.dl-dsearch-feat');
          if(!feat){ return; }
          var got = cardsFrom(html, 4);
          feat.innerHTML = '';
          feat.appendChild(got.frag);
        })
        .catch(function(){});
    }

    var t = null, lastReq = 0;
    function setSearching(on){ drawer.classList.toggle('dl-searching', on); }
    function reset(){ input.value = ''; clear.hidden = true; setSearching(false); results.hidden = true; results.innerHTML = ''; }

    function render(q, cards, total, colls){
      results.innerHTML = '';
      if(colls && colls.length){
        var sec = document.createElement('div'); sec.className = 'dl-dsearch-sec'; sec.textContent = 'Kolekce';
        results.appendChild(sec);
        colls.slice(0,3).forEach(function(c){
          var a = document.createElement('a'); a.className = 'dl-dsearch-coll'; a.href = c.url; a.textContent = c.title;
          results.appendChild(a);
        });
      }
      if(cards){ results.appendChild(cards); }
      if(!total && !(colls && colls.length)){
        var e = document.createElement('div'); e.className = 'dl-dsearch-empty';
        e.textContent = 'Pro tento dotaz jsme nic nenašli.';
        results.appendChild(e);
      }
      /* The section hands back the whole first page, so the count is real now rather than inferred
         from a capped API: more than the ten shown means there genuinely are more. */
      if(total > 10 || !total){
        var all = document.createElement('a'); all.className = 'dl-dsearch-all';
        all.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        all.textContent = 'Všechny výsledky →';
        results.appendChild(all);
      }
    }

    /* Typo-forgiving spellings, tried in order and only when the previous one found nothing.
       fold() strips diacritics (svitidlo for svítidlo) and collapses doubled letters (lucerrna for
       lucerna) - between them these cover the everyday Czech mistypes. The c/k, s/z and i/y pairs
       are then tried as whole-word swaps, which catches "kolekce"/"colekce" and "svitidlo"/"svytidlo"
       but is a guess, not a spell checker: a wrong guess simply returns nothing and costs one
       request. Real typo tolerance needs a search index rather than Shopify's suggest endpoint. */
    function fold(str){
      var v = String(str).toLowerCase();
      if(v.normalize){ v = v.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
      return v.replace(/(.)\1+/g, '$1');
    }
    function spellings(q){
      var out = [q], base = fold(q);
      function add(v){ if(v && out.indexOf(v) < 0){ out.push(v); } }
      add(base);
      /* Swap the FIRST occurrence only, not every one. Replacing all of them turns "colekce" into
         "kolekke" and never reaches "kolekce"; swapping just the first gets it in one, and mistypes
         cluster at the start of a word anyway. */
      var pairs = [['c','k'],['k','c'],['s','z'],['z','s'],['y','i'],['i','y']];
      for(var i = 0; i < pairs.length && out.length < 4; i++){
        var at = base.indexOf(pairs[i][0]);
        if(at >= 0){ add(base.slice(0, at) + pairs[i][1] + base.slice(at + 1)); }
      }
      return out.slice(0, 4);
    }

    function onInput(){
      var q = input.value.trim(); clear.hidden = !q; clearTimeout(t);
      if(!q){ setSearching(false); results.hidden = true; results.innerHTML = ''; return; }
      setSearching(true); results.hidden = false;
      t = setTimeout(function(){
        var id = ++lastReq, tries = spellings(q), i = 0;
        /* resources[limit] is a SHARED budget across the requested types, not a per-type one:
           asking for query+collection+product with limit 10 returned 5 products and 5 query
           suggestions for "tolomeo", and collection+product returned 5 and 5 for "svitidlo" - which
           is why a brand with dozens of products looked like it had five. Products therefore get a
           request of their own with the full budget, and collections a small parallel one. The
           query suggestions are not requested at all; nothing rendered them. */
        function collectionsFor(term){
          return fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=collection&resources[limit]=3', { headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); })
            .then(function(d){ return ((d && d.resources && d.resources.results) || {}).collections || []; })
            .catch(function(){ return []; });
        }
        function attempt(){
          var term = tries[i++];
          return Promise.all([
            fetch('/search?q=' + encodeURIComponent(term) + '&type=product&section_id=dl-search-results', { headers: { 'Accept': 'text/html' } }).then(function(r){ return r.text(); }),
            collectionsFor(term)
          ]).then(function(both){
            if(id !== lastReq){ return; }
            var got = cardsFrom(both[0], 10), colls = both[1];
            /* Next spelling only when this one found nothing at all, so a search that works never
               pays for a retry. */
            if(!got.total && !colls.length && i < tries.length){ return attempt(); }
            render(q, got.frag, got.total, colls);
          });
        }
        attempt().catch(function(){ if(id === lastReq){ results.innerHTML = '<div class="dl-dsearch-empty">Vyhledávání je dočasně nedostupné.</div>'; } });
      }, 180);
    }
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ var q = input.value.trim(); if(q){ window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; } } });
    clear.addEventListener('click', function(){ reset(); input.focus(); });

    var backdrop = document.createElement('div');
    backdrop.className = 'dl-drawer-backdrop';
    document.body.appendChild(backdrop);
    function openDrawer(focus){ drawer.classList.add('open'); backdrop.classList.add('show'); loadFeatured(); if(focus){ setTimeout(function(){ input.focus(); }, 90); } }
    function closeDrawer(){ drawer.classList.remove('open'); backdrop.classList.remove('show'); reset(); }
    backdrop.addEventListener('click', closeDrawer);
    /* 2026-10-05: Esc closes the drawer like the backdrop does. Every other dl surface already
       closed on Esc; this one only had the backdrop and its ✕ (now the shared .dl-x). */
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('open')){ closeDrawer(); } });
    var xbtn = drawer.querySelector('.hd .x');
    if(xbtn){ xbtn.addEventListener('click', closeDrawer); }
    var burger = document.querySelector('[data-navx] .navx-burger');
    if(burger){ burger.addEventListener('click', function(){ if(mq.matches){ backdrop.classList.add('show'); loadFeatured(); } }); }

    document.addEventListener('click', function(e){
      if(!mq.matches){ return; }
      var b = e.target.closest && e.target.closest('[data-search-open], .navx-find');
      if(!b){ return; }
      e.preventDefault(); e.stopPropagation();
      openDrawer(true);
    }, true);
  })();

  /* Desktop search takeover ✕: clear text if any, else close. */
  document.addEventListener('click', function(e){
    if(mq.matches){ return; }
    var btn = e.target.closest && e.target.closest('[data-navx-search] [data-search-close]');
    if(!btn){ return; }
    var input = document.querySelector('[data-navx-search] [data-search-input]');
    if(input && input.value.trim() !== ''){
      e.stopPropagation(); e.preventDefault();
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }
  }, true);

  /* Desktop: click dimmed area outside the search panel to close the takeover. */
  document.addEventListener('click', function(e){
    if(mq.matches){ return; }
    var s = document.querySelector('[data-navx-search]');
    if(!s || s.hidden){ return; }
    if(e.target.closest('.navx-search-in')){ return; }
    s.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function(){ s.hidden = true; }, 200);
  }, true);
})();